/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Form, Spin, Tabs, TabsProps } from "antd";
import CrewYard from "./CrewYard";
import { useForm } from "react-hook-form";
import Property from "./Property";
import CustomAddress from "./CustomAddress";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  loading: boolean;
  btnApi: () => void;
  title: string;
  paragraph: string;
}

const EditStartFinishPoint = (props: PropsType) => {
  const { onClose, loading, title, paragraph, btnApi } = props;

  const onCloseHandler = () => {
    onClose();
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (val: any) => {
    console.log(val);
    btnApi();
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Crew yard",
      children: <CrewYard control={control} errors={errors} />,
    },
    {
      key: "2",
      label: "Property",
      children: <Property control={control} errors={errors} />,
    },
    {
      key: "3",
      label: "Custom address",
      children: <CustomAddress control={control} errors={errors} />,
    },
  ];

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper scheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> {title} </h3>
            <p style={{ color: "#151718" }}>{paragraph}</p>
          </div>
        </div>
        <Form
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
        >
          <div className="modal_content">
            <Tabs defaultActiveKey="1" items={items} className="profileTabs" />
          </div>

          <div className="modal_footer">
            <Button
              htmlType="button"
              className="outlined-btn"
              type="default"
              size="large"
              onClick={onCloseHandler}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              className="mint-btn"
              type="primary"
              size="large"
            >
              Save changes
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default EditStartFinishPoint;
